import { render, staticRenderFns } from "./EditInlandVesselPractice.vue?vue&type=template&id=da162b28"
import script from "./EditInlandVesselPractice.vue?vue&type=script&lang=ts"
export * from "./EditInlandVesselPractice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports